// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2NbWJ","label":"CategoryService_label__3jM-O","location":"CategoryService_location__2YCYh"};